<template>
    <p class="uik-headline-desc__wrapper">
        <slot></slot>
    </p>
</template>

<script>
export default {
    name: "UikHeadlineDesc",
    props: {
        margin: { type: Boolean, default: false }
    }
}
</script>

<style lang="scss">
.uik-headline-desc__wrapper {
  & + * {
    margin-top: 20px;
  }
}
</style>
